/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import "./Panel.css";
import { Card } from "react-bootstrap";
import PropTypes from "prop-types";

/**
 * This component is the base card that all of our displays sit on in the dashboard.
 * It takes in a title, children for the card body, and style if the user wishes to
 * specify specifics on the styling of the outer card.
 * @param {string} title The title of the card.
 * @param {node} children The react node to be displayed as the content of this card.
 * @param {Object} style An optional object to denote specific styling for the card.
 * @param {node} headerContent An optional react node for adding something to the header object.
 */
const Panel = ({ title, children, style, headerContent }) => (
	<Card className={"panel"} style={style}>
		<Card.Header style={{ padding: "5px 15px", display: "flex", justifyContent: "space-between" }}>
			<h5
				className="pt-1"
				style={{
					fontSize: "0.875rem",
					lineHeight: 1.8,
					fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
					color: "#666",
				}}
			>
				{title}
			</h5>
			<span>{headerContent}</span>
		</Card.Header>
		<div className="panel-content">{children}</div>
	</Card>
);

Panel.propTypes = {
	title: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	style: PropTypes.object,
	headerContent: PropTypes.node,
};

export default Panel;
